import notFoundImage from '../assets/images/no-image-found.jpg';

import Asscher from '../assets/images/diamond-images/Asscher.png';
import Cushion from '../assets/images/diamond-images/Cushion.png';
import Emerald from '../assets/images/diamond-images/Emerald.png';
import Heart from '../assets/images/diamond-images/Heart.png';
import Marquise from '../assets/images/diamond-images/Marquise.png';
import Oval from '../assets/images/diamond-images/Oval.png';
import Pear from '../assets/images/diamond-images/Pear.png';
import Princess from '../assets/images/diamond-images/Princess.png';
import Radiant from '../assets/images/diamond-images/Radiant.png';
import Round from '../assets/images/diamond-images/Round.png';
import SignatureOval from '../assets/images/diamond-images/SignatureOval.png';
import SignatureRound from '../assets/images/diamond-images/SignatureRound.png';
import SignatureSquare from '../assets/images/diamond-images/SignatureSquare.png';

import AsscherCompositeRG from '../assets/images/diamond-composites/AsscherRG.png';
import AsscherCompositeWG from '../assets/images/diamond-composites/AsscherWG.png';
import AsscherCompositeYG from '../assets/images/diamond-composites/AsscherYG.png';
import CushionCompositeRG from '../assets/images/diamond-composites/CushionRG.png';
import CushionCompositeWG from '../assets/images/diamond-composites/CushionWG.png';
import CushionCompositeYG from '../assets/images/diamond-composites/CushionYG.png';
import EmeraldCompositeRG from '../assets/images/diamond-composites/EmeraldRG.png';
import EmeraldCompositeWG from '../assets/images/diamond-composites/EmeraldWG.png';
import EmeraldCompositeYG from '../assets/images/diamond-composites/EmeraldYG.png';
import HeartCompositeRG from '../assets/images/diamond-composites/HeartRG.png';
import HeartCompositeWG from '../assets/images/diamond-composites/HeartWG.png';
import HeartCompositeYG from '../assets/images/diamond-composites/HeartYG.png';
import MarquiseCompositeRG from '../assets/images/diamond-composites/MarquiseRG.png';
import MarquiseCompositeWG from '../assets/images/diamond-composites/MarquiseWG.png';
import MarquiseCompositeYG from '../assets/images/diamond-composites/MarquiseYG.png';
import OvalCompositeRG from '../assets/images/diamond-composites/OvalRG.png';
import OvalCompositeWG from '../assets/images/diamond-composites/OvalWG.png';
import OvalCompositeYG from '../assets/images/diamond-composites/OvalYG.png';
import OvalHaloCompositeRG from '../assets/images/diamond-composites/OvalHaloRG.png';
import OvalHaloCompositeWG from '../assets/images/diamond-composites/OvalHaloWG.png';
import OvalHaloCompositeYG from '../assets/images/diamond-composites/OvalHaloYG.png';
import PearCompositeRG from '../assets/images/diamond-composites/PearRG.png';
import PearCompositeWG from '../assets/images/diamond-composites/PearWG.png';
import PearCompositeYG from '../assets/images/diamond-composites/PearYG.png';
import PrincessCompositeRG from '../assets/images/diamond-composites/PrincessRG.png';
import PrincessCompositeWG from '../assets/images/diamond-composites/PrincessWG.png';
import PrincessCompositeYG from '../assets/images/diamond-composites/PrincessYG.png';
import RadiantCompositeRG from '../assets/images/diamond-composites/RadiantRG.png';
import RadiantCompositeWG from '../assets/images/diamond-composites/RadiantWG.png';
import RadiantCompositeYG from '../assets/images/diamond-composites/RadiantYG.png';
import RoundCompositeRG from '../assets/images/diamond-composites/RoundRG.png';
import RoundCompositeWG from '../assets/images/diamond-composites/RoundWG.png';
import RoundCompositeYG from '../assets/images/diamond-composites/RoundYG.png';
import Round6CompositeRG from '../assets/images/diamond-composites/Round6RG.png';
import Round6CompositeWG from '../assets/images/diamond-composites/Round6WG.png';
import Round6CompositeYG from '../assets/images/diamond-composites/Round6YG.png';
import RoundHaloCompositeRG from '../assets/images/diamond-composites/RoundHaloRG.png';
import RoundHaloCompositeWG from '../assets/images/diamond-composites/RoundHaloWG.png';
import RoundHaloCompositeYG from '../assets/images/diamond-composites/RoundHaloYG.png';
import RoundSquareHaloCompositeRG from '../assets/images/diamond-composites/RoundSquareHaloRG.png';
import RoundSquareHaloCompositeWG from '../assets/images/diamond-composites/RoundSquareHaloWG.png';
import RoundSquareHaloCompositeYG from '../assets/images/diamond-composites/RoundSquareHaloYG.png';

import product2FSSY4627 from '../assets/images/diamond-composites/2FSSY4627.png';
import product2SM000523 from '../assets/images/diamond-composites/2SM000523.png';
import product2SM000525 from '../assets/images/diamond-composites/2SM000525.png';
import product2SM000526 from '../assets/images/diamond-composites/2SM000526.png';
import product2SM000538 from '../assets/images/diamond-composites/2SM000538.png';
import product2SM000539 from '../assets/images/diamond-composites/2SM000539.png';

import product2FSSY4627Oval from '../assets/images/diamond-composites/2FSSY4627-oval.png';
import product2SM000523Oval from '../assets/images/diamond-composites/2SM000523-oval.png';
import product2SM000525Oval from '../assets/images/diamond-composites/2SM000525-oval.png';
import product2SM000526Oval from '../assets/images/diamond-composites/2SM000526-oval.png';

import AsscherSide from '../assets/images/diamond-sides/Asscher.svg';
import CushionSide from '../assets/images/diamond-sides/Cushion.svg';
import EmeraldSide from '../assets/images/diamond-sides/Emerald.svg';
import HeartSide from '../assets/images/diamond-sides/Heart.svg';
import MarquiseSide from '../assets/images/diamond-sides/Marquise.svg';
import OvalSide from '../assets/images/diamond-sides/Oval.svg';
import PearSide from '../assets/images/diamond-sides/Pear.svg';
import PrincessSide from '../assets/images/diamond-sides/Princess.svg';
import RadiantSide from '../assets/images/diamond-sides/Radiant.svg';
import RoundSide from '../assets/images/diamond-sides/Round.svg';
import SignatureOvalSide from '../assets/images/diamond-sides/SignatureOval.svg';
import SignatureRoundSide from '../assets/images/diamond-sides/SignatureRound.svg';
import SignatureSquareSide from '../assets/images/diamond-sides/SignatureSquare.svg';

import AsscherTop from '../assets/images/diamond-tops/Asscher.svg';
import CushionTop from '../assets/images/diamond-tops/Cushion.svg';
import EmeraldTop from '../assets/images/diamond-tops/Emerald.svg';
import HeartTop from '../assets/images/diamond-tops/Heart.svg';
import MarquiseTop from '../assets/images/diamond-tops/Marquise.svg';
import OvalTop from '../assets/images/diamond-tops/Oval.svg';
import PearTop from '../assets/images/diamond-tops/Pear.svg';
import PrincessTop from '../assets/images/diamond-tops/Princess.svg';
import RadiantTop from '../assets/images/diamond-tops/Radiant.svg';
import RoundTop from '../assets/images/diamond-tops/Round.svg';
import SignatureOvalTop from '../assets/images/diamond-tops/SignatureOval.svg';
import SignatureRoundTop from '../assets/images/diamond-tops/SignatureRound.svg';
import SignatureSquareTop from '../assets/images/diamond-tops/SignatureSquare.svg';

import Bold from '../assets/images/facet-settings/Bold.png';
import Channel from '../assets/images/facet-settings/Channel.png';
import Halo from '../assets/images/facet-settings/Halo.png';
import Prong from '../assets/images/facet-settings/Prong.png';
import SideStone from '../assets/images/facet-settings/SideStone.png';
import Solitaire from '../assets/images/facet-settings/Solitaire.png';
import Unique from '../assets/images/facet-settings/Unique.png';
import Vintage from '../assets/images/facet-settings/Vintage.png';

export const SETTING_STEP = 1;
export const PRODUCT_SELECTION_STEP = 2;
export const DIAMOND_STEP = 3;
export const REVIEW_STEP = 4;

export const DEFAULT_TITLE_PREFIX = 'Design Your';
export const DEFAULT_TITLE = `${DEFAULT_TITLE_PREFIX} Engagement Ring`;

export const PRODUCT_ATTRIBUTES_PARAM_KEY = 'Product_Attributes';

export const START_WITH_DIAMOND_URI = '/design-your-engagement-ring/start-with-diamond';
export const START_WITH_LAB_DIAMOND_URI = '/design-your-engagement-ring/start-with-lab-diamond';
export const START_WITH_SETTING_URI = '/design-your-engagement-ring/start-with-setting';

export const SETTING_CLIENT_GUID = window.env.HAWK_SEARCH_CLIENT_GUID;
export const DIAMOND_CLIENT_GUID = window.env.HAWK_DIAMOND_CLIENT_GUID;
export const DIAMOND_CLIENT_SEARCH_ENDPOINT = window.env.HAWK_DIAMOND_CLIENT_SEARCH_ENDPOINT;
export const DIAMOND_CLIENT_TRACKING_ENDPOINT = window.env.HAWK_DIAMOND_CLIENT_TRACKING_ENDPOINT;

export const DIAMOND_PLACEHOLDER = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6I2Y5ZjlmOCI+PC9zdmc+';
export const DIAMOND_NOT_FOUND_IMAGE = notFoundImage;

export const SETTING_PLACEHOLDER = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNjAiIGhlaWdodD0iMzYwIiBzdHlsZT0iYmFja2dyb3VuZC1jb2xvcjojZjlmOWY4Ij48L3N2Zz4=';
export const SETTING_NOT_FOUND_IMAGE = notFoundImage;

export const DIAMOND_PREVIEW_MIN_CARAT = 0.5;
export const DIAMOND_PREVIEW_MAX_CARAT = 2.50;

export const DIAMOND_COMPOSITES = {
	asscher: {
		RG: {
			default: AsscherCompositeRG
		},
		WG: {
			default: AsscherCompositeWG
		},
		YG: {
			default: AsscherCompositeYG
		}
	},
	cushion: {
		RG: {
			default: CushionCompositeRG
		},
		WG: {
			default: CushionCompositeWG
		},
		YG: {
			default: CushionCompositeYG
		}
	},
	emerald: {
		RG: {
			default: EmeraldCompositeRG
		},
		WG: {
			default: EmeraldCompositeWG
		},
		YG: {
			default: EmeraldCompositeYG
		}
	},
	heart: {
		RG: {
			default: HeartCompositeRG
		},
		WG: {
			default: HeartCompositeWG
		},
		YG: {
			default: HeartCompositeYG
		}
	},
	marquise: {
		RG: {
			default: MarquiseCompositeRG
		},
		WG: {
			default: MarquiseCompositeWG
		},
		YG: {
			default: MarquiseCompositeYG
		}
	},
	oval: {
		RG: {
			default: OvalCompositeRG,
			halo: OvalHaloCompositeRG
		},
		WG: {
			default: OvalCompositeWG,
			halo: OvalHaloCompositeWG
		},
		YG: {
			default: OvalCompositeYG,
			halo: OvalHaloCompositeYG
		}
	},
	pear: {
		RG: {
			default: PearCompositeRG
		},
		WG: {
			default: PearCompositeWG
		},
		YG: {
			default: PearCompositeYG
		}
	},
	princess: {
		RG: {
			default: PrincessCompositeRG
		},
		WG: {
			default: PrincessCompositeWG
		},
		YG: {
			default: PrincessCompositeYG
		}
	},
	products: {
		'2FSSY4627': {
			oval: product2FSSY4627Oval,
			round: product2FSSY4627
		},
		'2SM000523': {
			oval: product2SM000523Oval,
			round: product2SM000523
		},
		'2SM000525': {
			oval: product2SM000525Oval,
			round: product2SM000525
		},
		'2SM000526': {
			oval: product2SM000526Oval,
			round: product2SM000526
		},
		'2SM000538': {
			oval: product2SM000538,
			round: product2SM000538
		},
		'2SM000539': {
			oval: product2SM000539,
			round: product2SM000539
		}
	},
	radiant: {
		RG: {
			default: RadiantCompositeRG
		},
		WG: {
			default: RadiantCompositeWG
		},
		YG: {
			default: RadiantCompositeYG
		}
	},
	round: {
		RG: {
			default: RoundCompositeRG,
			halo: RoundHaloCompositeRG,
			sixprong: Round6CompositeRG,
			squarehalo: RoundSquareHaloCompositeRG
		},
		WG: {
			default: RoundCompositeWG,
			halo: RoundHaloCompositeWG,
			sixprong: Round6CompositeWG,
			squarehalo: RoundSquareHaloCompositeWG
		},
		YG: {
			default: RoundCompositeYG,
			halo: RoundHaloCompositeYG,
			sixprong: Round6CompositeYG,
			squarehalo: RoundSquareHaloCompositeYG
		}
	},
	'signature-oval': {
		RG: {
			default: OvalCompositeRG,
			halo: OvalHaloCompositeRG
		},
		WG: {
			default: OvalCompositeWG,
			halo: OvalHaloCompositeWG
		},
		YG: {
			default: OvalCompositeYG,
			halo: OvalHaloCompositeYG
		}
	},
	'signature-round': {
		RG: {
			default: RoundCompositeRG,
			halo: RoundHaloCompositeRG
		},
		WG: {
			default: RoundCompositeWG,
			halo: RoundHaloCompositeWG
		},
		YG: {
			default: RoundCompositeYG,
			halo: RoundHaloCompositeYG
		}
	},
	'signature-square': {
		RG: {
			default: PrincessCompositeRG
		},
		WG: {
			default: PrincessCompositeWG
		},
		YG: {
			default: PrincessCompositeYG
		}
	}
};

export const DIAMOND_IMAGES = {
	asscher: Asscher,
	cushion: Cushion,
	emerald: Emerald,
	heart: Heart,
	marquise: Marquise,
	oval: Oval,
	pear: Pear,
	princess: Princess,
	radiant: Radiant,
	round: Round,
	'signature-oval': SignatureOval,
	'signature-round': SignatureRound,
	'signature-square': SignatureSquare
};

export const DIAMOND_SIDES = {
	asscher: AsscherSide,
	cushion: CushionSide,
	emerald: EmeraldSide,
	heart: HeartSide,
	marquise: MarquiseSide,
	oval: OvalSide,
	pear: PearSide,
	princess: PrincessSide,
	radiant: RadiantSide,
	round: RoundSide,
	'signature-oval': SignatureOvalSide,
	'signature-round': SignatureRoundSide,
	'signature-square': SignatureSquareSide
};

export const DIAMOND_TOPS = {
	asscher: AsscherTop,
	cushion: CushionTop,
	emerald: EmeraldTop,
	heart: HeartTop,
	marquise: MarquiseTop,
	oval: OvalTop,
	pear: PearTop,
	princess: PrincessTop,
	radiant: RadiantTop,
	round: RoundTop,
	'signature-oval': SignatureOvalTop,
	'signature-round': SignatureRoundTop,
	'signature-square': SignatureSquareTop
};

export const FACET_SETTINGS = {
	bold: Bold,
	channel: Channel,
	halo: Halo,
	prong: Prong,
	sidestone: SideStone,
	solitaire: Solitaire,
	unique: Unique,
	vintage: Vintage
};

/* eslint-disable sort-keys */
export const DIAMOND_CLARITY_MAPPING = {
	0: 'FL',
	1: 'IF',
	2: 'VVS1',
	3: 'VVS2',
	4: 'VS1',
	5: 'VS2',
	6: 'SI1',
	7: 'SI2',
	8: 'I1',
	9: 'I2',
	10: 'I3'
};

export const DIAMOND_COLOR_MAPPING = {
	0: 'D',
	1: 'E',
	2: 'F',
	3: 'G',
	4: 'H',
	5: 'I',
	6: 'J',
	7: 'K',
	8: 'L',
	9: 'M'
};

export const DIAMOND_POLISH_MAPPING = {
	0: {
		facet: 'EX',
		result: 'Excellent'
	},
	1: {
		facet: 'VG',
		result: 'Very Good'
	},
	2: {
		facet: 'G',
		result: 'Good'
	},
	3: {
		facet: 'F',
		result: 'Fair'
	},
	4: {
		facet: 'FNT',
		result: 'Faint'
	}
};

export const DIAMOND_SYMMETRY_MAPPING = {
	0: {
		facet: 'EX',
		result: 'Excellent'
	},
	1: {
		facet: 'VG',
		result: 'Very Good'
	},
	2: {
		facet: 'G',
		result: 'Good'
	},
	3: {
		facet: 'F',
		result: 'Fair'
	},
	4: {
		facet: 'FNT',
		result: 'Faint'
	}
};

export const DIAMOND_FLUORESCENCE_MAPPING = {
	0: {
		facet: 'VST',
		result: 'VST'
	},
	1: {
		facet: 'ST',
		result: 'ST'
	},
	2: {
		facet: 'MED',
		result: 'MED'
	},
	3: {
		facet: 'FNT',
		result: 'FNT'
	},
	4: {
		facet: 'N',
		result: 'N'
	}
};
/* eslint-enable sort-keys */

/**
 * Maps each shape's carat to width in millimeters. Used to create a polynomial regression model.
 * @see https://www.npmjs.com/package/regression#regressionpolynomialdata-options
 * @constant
 */
export const DIAMOND_PREVIEW_MEASUREMENT_DATA = {
	Asscher: [
		[
			1.00,
			5.5
		],
		[
			1.25,
			6
		],
		[
			1.50,
			6.5
		],
		[
			1.75,
			6.75
		],
		[
			2.00,
			7
		],
		[
			2.25,
			7.25
		],
		[
			2.50,
			7.5
		]
	],
	Cushion: [
		[
			1.00,
			5.5
		],
		[
			1.25,
			6
		],
		[
			1.50,
			6.5
		],
		[
			1.75,
			7
		],
		[
			2.00,
			7.5
		],
		[
			2.25,
			7.75
		],
		[
			2.50,
			8
		]
	],
	Emerald: [
		[
			1.00,
			7
		],
		[
			1.25,
			7.3
		],
		[
			1.50,
			7.5
		],
		[
			1.75,
			8
		],
		[
			2.00,
			8.5
		],
		[
			2.25,
			8.75
		],
		[
			2.50,
			9
		]
	],
	Heart: [
		[
			1.00,
			6.5
		],
		[
			1.25,
			7
		],
		[
			1.50,
			7.5
		],
		[
			1.75,
			7.75
		],
		[
			2.00,
			8
		],
		[
			2.25,
			8.25
		],
		[
			2.50,
			8.5
		]
	],
	Marquise: [
		[
			1.00,
			7.7
		],
		[
			1.25,
			8
		],
		[
			1.50,
			8.5
		],
		[
			1.75,
			8.85
		],
		[
			2.00,
			9
		],
		[
			2.25,
			9.25
		],
		[
			2.50,
			9.5
		]
	],
	Oval: [
		[
			1.00,
			7.7
		],
		[
			1.25,
			8
		],
		[
			1.50,
			8.5
		],
		[
			1.75,
			8.85
		],
		[
			2.00,
			9
		],
		[
			2.25,
			9.25
		],
		[
			2.50,
			9.5
		]
	],
	Pear: [
		[
			1.00,
			7.7
		],
		[
			1.25,
			8
		],
		[
			1.50,
			8.5
		],
		[
			1.75,
			8.7
		],
		[
			2.00,
			9
		],
		[
			2.25,
			9.2
		],
		[
			2.50,
			9.5
		]
	],
	Princess: [
		[
			1.00,
			5.5
		],
		[
			1.25,
			6
		],
		[
			1.50,
			6.5
		],
		[
			1.75,
			6.75
		],
		[
			2.00,
			7
		],
		[
			2.25,
			7.25
		],
		[
			2.50,
			7.5
		]
	],
	Radiant: [
		[
			1.00,
			6.25
		],
		[
			1.25,
			6.55
		],
		[
			1.50,
			6.85
		],
		[
			1.75,
			7.25
		],
		[
			2.00,
			7.55
		],
		[
			2.25,
			7.85
		],
		[
			2.50,
			8
		]
	],
	Round: [
		[
			1.00,
			6.5
		],
		[
			1.25,
			6.8
		],
		[
			1.50,
			7.3
		],
		[
			1.75,
			7.75
		],
		[
			2.00,
			8
		],
		[
			2.25,
			8.25
		],
		[
			2.50,
			8.5
		]
	]
};

export const SHAPE_CARAT_FACET_FIELDS = [
	'asscher_carat',
	'cushion_carat',
	'emerald_carat',
	'heart_carat',
	'marquise_carat',
	'oval_carat',
	'pear_carat',
	'princess_carat',
	'radiant_carat',
	'round_carat'
];
